import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HdComponentModule } from "./hd-component.module";
import { HdLogComponent } from './hd-log/hd-log.component';
import { HdOverlayCleanupService } from './service/hd-overlay-cleanup.service';
@NgModule({
  imports: [CommonModule],
  exports: [HdComponentModule],
  providers: [],
  entryComponents: [HdLogComponent]
})
export class FantasyNgzorroModule {
  // 注入以启动全局 tooltip overlay 清理（providedIn: root，幂等）
  constructor(_overlayCleanup: HdOverlayCleanupService) {}
}
